import { Controller } from "@hotwired/stimulus"

// Auto-detects browser timezone and sends it to the server if it differs
// from the user's stored timezone. Runs once on connect.
export default class extends Controller {
  static values = { current: String, url: String }

  connect() {
    const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!browserTz) return

    // Skip if already matching
    if (this.currentValue === browserTz) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    if (!token) return

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({ timezone: browserTz })
    }).then(response => {
      if (response.ok) {
        // Reload to apply the new timezone to greeting/time display
        window.location.reload()
      }
    }).catch(() => {
      // Silently fail - timezone detection is best-effort
    })
  }
}
